import enLang from './entries/en_US';
import thLang from './entries/th_TH';

const AppLocale = {
    th: thLang,
    en: enLang
};

export default AppLocale;